<app-search-overlay *ngIf="config"
  [config]="config"
  (open)="onOpen()"
  [canEdit]="canEdit"
  (change)="onChange($event); change.emit($event)">
</app-search-overlay>

<ng-template #selectedTemplate>
  <div class="d-flex align-items-center" *ngFor="let user of config.selecteds">
    <app-avatar [url]="user.avatar" [name]="user.fullName">
    </app-avatar>
    <div *ngIf="showFullname" class="ml-2 text-dark"> {{ user.fullName }} </div>
  </div>

  <app-avatar *ngIf="config.selecteds.length == 0"></app-avatar>
</ng-template>

<ng-template #optionTemplate let-item="item">
  <app-avatar [url]="item.avatar" [name]="item.fullName"></app-avatar>
  <span class="option-label">{{item.fullName}}</span>
</ng-template>
